import React from "react";
import LocationItem from "./LocationItem";
import { useTranslation } from "react-i18next";

interface LocationSearchProps {
  seo: boolean;
}

const locations = ["Colle Val d'Elsa", "Casole d'Elsa", "Monteriggioni", "San Gimignano"];

const LocationSearch: React.FC<LocationSearchProps> = ({ seo }) => {
  const { t } = useTranslation();
  return (
    <section className="space-ptb">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-title text-center">
              {seo ? (
                <h2>{t('homePage.locationsSection.title1')}</h2>
              ) : (
                <h3 className="asH2SubTitle">{t('homePage.locationsSection.title2')}</h3>
              )}
              <p>{t('homePage.locationsSection.paragraph')}</p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center justify-content-lg-around">
          {locations.map((location, idx) => (
            <LocationItem key={idx} location={location} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LocationSearch;